import React from 'react';
import FriendsThink from '../templates/FriendsThink'
import CardStackHOC from '../components/CardStackHOC'

const ShareCardHOC = (props) => {

  const shareLink = encodeURIComponent('http://www.match.com/ratethedatelook/')
  const twitterText = encodeURIComponent('Rate these date looks! @Match & @HerFinery are teaming up to help you look great and win big.')
  const twitterVia = encodeURIComponent('match')
  const facebookLink = 'https://www.facebook.com/dialog/feed?'
  +'app_id=114828211898596'
  +'&display=popup&amp;caption=Rate%20these%20date%20looks!'
  +'&link='+shareLink
  +'&redirect_uri='+shareLink

  const twitterShare = () => {
    const twitterLink = 'https://twitter.com/intent/tweet?url='+shareLink+'&text='+twitterText+'&via='+twitterVia
    window.open(twitterLink)
  }

  const facebookShare = () => {
    window.location.href = facebookLink
  }

  const rateMoreLooksHandler = () => {
    const path = `/ratethelook/${props.match.params.gender}/2`
    props.history.push(path)
  }

  return (

        <CardStackHOC buttonText={`VIEW MORE LOOKS`} buttonClickHandler={rateMoreLooksHandler} >
          <FriendsThink gender={props.match.params.gender} twitterShare={twitterShare} facebookShare={facebookShare}>
            <div className="keepRating">Want to keep rating?</div>
          </FriendsThink>
        </CardStackHOC>
      )
}

export default ShareCardHOC;



// WEBPACK FOOTER //
// ./src/components/ShareCardHOC.js